import { useNavigate } from 'react-router-dom';

/**
 * 「前ページに戻る」ボタン用カスタムフック
 *
 * ■ 挙動
 *   1. ブラウザ履歴がある場合 → navigate(-1) で前のページに戻る
 *      - 案件詳細のタブ状態（?tab=xxx）も自然に復元される
 *   2. ブラウザ履歴がない場合 → fallbackUrl へ遷移する
 *      - 直接URL入力やブックマークからのアクセス時に該当
 *
 * ■ 各ページでの使用例
 *   - 案件詳細:      useNavigateBack('/')
 *   - 活動詳細:      useNavigateBack(`/opportunity/${id}?tab=activities`)
 *   - 提案求人詳細:  useNavigateBack(`/opportunity/${id}?tab=proposed_jobs`)
 *
 * @param {string} fallbackUrl - 履歴がない場合のフォールバック先URL（デフォルト: '/'）
 * @returns {Function} onClick ハンドラとして使える関数
 */
const useNavigateBack = (fallbackUrl = '/') => {
    const navigate = useNavigate();
    return () => {
        if (window.history.length > 1) {
            navigate(-1);
        } else {
            navigate(fallbackUrl);
        }
    };
};

export default useNavigateBack;
